<template>
  <div>
    <div class="text-subtitle-4 neutral-040--text mb-3 d-flex align-center">
      <v-btn
        icon
        small
        target="_blank"
        class="mr-1"
        :href="omnichatDocs + 'features/omo-she-ding/dian-yuan-pai-ban-guan-li#zi-dong-hui-fu'"
      >
        <v-icon color="neutral-044">
          mdi-help-circle
        </v-icon>
      </v-btn>
      {{ $t('STAFF_MANAGEMENT.AUTO_REPLY_DURING_OFF_BUSINESS_HOURS') }}
    </div>
    <v-card
      class="py-7 px-4 text-body-3 neutral-041--text mb-5"
      color="warning-034"
      min-height="106"
      flat
    >
      <div class="mb-3">
        {{ $t('SHOP_MANAGEMENT.INFO') }}
      </div>
      <div v-html="$t('STAFF_MANAGEMENT.OFFLINE_AUTO_REPLY_REMINDER')" />
    </v-card>
    <!-- 所有分店自動回覆 -->
    <div class="text-subtitle-4 neutral-cold-051--text mb-2">
      {{ $t('STAFF_MANAGEMENT.AUTO_REPLY_FOR_ALL_STORES') }}
    </div>
    <div class="default-reply-textarea">
      <Textarea
        :placeholder="$t('STAFF_MANAGEMENT.PLEASE_ENTER_AUTO_REPLY_MESSAGE')"
        hide-details
        :rows="3"
        @blur="onBlur"
        @focus="onFocus"
        class="mb-6"
        v-model="defaultAutoReply"
        :disabled="!isAdminOrManager"
      />
      <div
        v-show="openTextareaTool"
        class="textarea-tool"
      >
        <div class="tool-btn-group">
          <v-btn
            @click.stop=""
            @mousedown="cancelEditDefaultAutoReply"
            icon
            text
            color="primary-005"
            max-width="32"
            max-height="32"
            class="tool-btn"
          >
            <v-img
              max-width="24"
              src="@/assets/images/general/icon_cancel.svg"
            />
          </v-btn>
          <v-btn
            @click.stop=""
            @mousedown="onMousedown"
            icon
            text
            color="primary-005"
            max-width="32"
            max-height="32"
            class="tool-btn"
          >
            <v-img
              max-width="24"
              src="@/assets/images/general/icon_confirm.svg"
            />
          </v-btn>
        </div>
      </div>
    </div>
    <!-- 所有分店自動回覆 END -->

    <!-- 指定分店自動回覆 -->
    <div class="store-auto-response-title">
      <div class="text-subtitle-4 neutral-cold-051--text mb-2">
        {{ $t('STAFF_MANAGEMENT.AUTO_REPLY_FOR_DESIGNATED_STORES') }}
      </div>
      <v-btn
        class="text-subtitle-4 add-action"
        color="primary-001"
        text
        small
        v-show="!isShowCreateAutoReply"
        @click="openAutoReplySetting"
      >
        <v-icon
          size="20"
          color="primary-001"
          class="mr-1"
        >
          mdi-plus
        </v-icon>
        {{ $t('CREATE') }}
      </v-btn>
    </div>
    <div class="store-auto-response">
      <div class="store-auto-response-list">
        <!-- 新增分店自動回覆 component -->
        <StoreAutoReplySetting
          v-show="isShowCreateAutoReply"
          :location-code.sync="tempCreateAutoReply.locationCode"
          :reply-body.sync="tempCreateAutoReply.replyBody"
          :is-submit-loading="tempCreateAutoReply.isSubmitLoading"
          @cancel-setting="() => isShowCreateAutoReply = false"
          @confirm-setting="createAutoReply(tempCreateAutoReply.locationCode, tempCreateAutoReply.replyBody)"
        />
        <!-- 顯示各分店回覆訊息 component -->
        <StoreAutoReply
          v-for="(autoReply, index) in autoReplyList"
          :key="index"
          v-bind="autoReply"
          @change-is-edit="(status) => autoReply.isEdit = status"
          @reload-Auto-Reply-List="fetchAutoReplyList"
          @auto-reply-delete-success="$refs.notification.openNotification({title: $t('NOTIFICATION.DELETE_SUCCESS'),status: 'success'})"
        />
        <!-- 沒有設定分店回覆訊息 component -->
        <div
          v-if="isShowEmptyData"
          class="store-auto-response-empty"
          @click="openAutoReplySetting"
        >
          <p class="text-body-1 neutral-042--text mb-4 text-center">
            {{ $t('STAFF_MANAGEMENT.NO_AUTO_REPLY_MESSAGES_HAVE_BEEN_SET') }}
          </p>
          <p
            class="mb-1 primary-001--text d-flex justify-center align-center"
          >
            <v-icon
              size="20"
              class="mr-1"
              color="primary-001"
            >
              $vuetify.icons.plusIcon
            </v-icon>
            {{ $t('CREATE') }}
          </p>
        </div>
      </div>
      <Notification
        ref="notification"
      />
    </div>
    <!-- 指定分店自動回覆  END-->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Textarea from '@/components/form/Textarea.vue';
import staffApi from '@/restapis/staffManagement';

import StoreAutoReply from './StoreAutoReply.vue';
import StoreAutoReplySetting from './StoreAutoReplySetting.vue';

export default {
  name: 'OfflineAutoReply',
  components: {
    Textarea,
    StoreAutoReply,
    StoreAutoReplySetting
  },
  props: {
    isAdminOrManager: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    isShowEmptyData() {
      if (this.autoReplyList.length === 0 && !this.isShowCreateAutoReply) return true;
      return false;
    }
  },
  data() {
    return {
      isShowCreateAutoReply: false,
      tempCreateAutoReply: {
        locationCode: '',
        replyBody: '',
        isSubmitLoading: false
      },
      autoReplyList: [],
      isSetDefaultAutoReply: false,
      defaultAutoReplyFromDB: '',
      defaultAutoReply: '',
      openTextareaTool: false,
      clickTextareaTool: false,
      omnichatDocs: this.$t('OMNICHAT_DOCS')
    };
  },
  methods: {
    onBlur() {
      if (this.clickTextareaTool) {
        this.clickTextareaTool = false;
        this.openTextareaTool = false;
        return;
      }
      this.handleDefaultAutoReply();
      this.openTextareaTool = false;
    },
    onFocus() {
      this.openTextareaTool = true;
    },
    onMousedown() {
      this.clickTextareaTool = true;
      this.handleDefaultAutoReply();
    },
    cancelEditDefaultAutoReply() {
      this.clickTextareaTool = true;
      this.defaultAutoReply = this.defaultAutoReplyFromDB;
    },
    handleDefaultAutoReply(e) {
      if (this.isSetDefaultAutoReply) {
        if (this.defaultAutoReply === this.defaultAutoReplyFromDB) return;
        this.updateDefaultAutoReply(this.defaultAutoReply);
      } else {
        this.createAutoReply('', this.defaultAutoReply);
      }
    },
    async updateDefaultAutoReply(defaultAutoReply) {
      const data = {
        locationCode: '',
        replyBody: defaultAutoReply
      };
      try {
        const response = await staffApi.updateOfflineAutoReply(data);
        if (response.status === 200) {
          const notificationObj = {
            title: this.$t('NOTIFICATION.UPDATE_SUCCESS'),
            status: 'success'
          };
          this.$refs.notification.openNotification(notificationObj);
        }
        this.fetchAutoReplyList();
      } catch (error) {
        this.isSubmitLoading = false;
        const { code, message } = error.response.data;
        const notificationObj = {
          title: this.$t('ERROR_MSG.UPDATE_FAIL'),
          content: `${code}-${message}`
        };
        this.$refs.notification.openNotification(notificationObj);
      }
    },
    async fetchAutoReplyList() {
      try {
        const response = await staffApi.getOfflineAutoReply();

        const list = response.data.data;
        const defaultAutoReplyIndex = list.findIndex((autoReply) => autoReply.locationCode === '');

        if (defaultAutoReplyIndex === -1) {
          this.isSetDefaultAutoReply = false;
        } else {
          this.isSetDefaultAutoReply = true;
          this.defaultAutoReplyFromDB = list[defaultAutoReplyIndex].replyBody;
          this.defaultAutoReply = list[defaultAutoReplyIndex].replyBody;
          list.splice(
            defaultAutoReplyIndex, 1
          );
        }

        this.autoReplyList = list.map((autoReply) => {
          autoReply.isEdit = false;
          autoReply.locationNameAndCode = `${this.getLocationNameFromCode(autoReply.locationCode)} (${autoReply.locationCode})`;
          return autoReply;
        });
      } catch (error) {
        const status = error.response.status;
        if (status === 403) {
          const notificationObj = {
            title: this.$t('ERROR_MSG.FORBIDDEN_PERMISSION_DENIED')
          };
          this.$refs.notification.openNotification(notificationObj);
          return;
        }
        this.handleOmoOfflineAutoReplyError();
      }
    },
    openAutoReplySetting() {
      this.resetTempCreateAutoReply();
      this.isShowCreateAutoReply = true;
    },
    getLocationNameFromCode(code) {
      const targetShop = this.currentUserDict.shopLocations.find((shop) => shop.code === code);
      return targetShop ? targetShop.name : '';
    },
    async createAutoReply(locationCode, replyBody) {
      this.tempCreateAutoReply.isSubmitLoading = true;
      const data = {
        locationCode: locationCode,
        replyBody: replyBody
      };
      try {
        const response = await staffApi.createOfflineAutoReply(data);
        if (response.status === 200) {
          const notificationObj = {
            title: this.$t('NOTIFICATION.CREATE_SUCCESS'),
            status: 'success'
          };
          this.$refs.notification.openNotification(notificationObj);
        }
        this.isShowCreateAutoReply = false;
        this.resetTempCreateAutoReply();
        this.fetchAutoReplyList();
      } catch (error) {
        const { code, message } = error.response.data;
        const locationName = this.getLocationNameFromCode(locationCode);
        this.handleOmoOfflineAutoReplyError(code, locationName);
        this.tempCreateAutoReply.isSubmitLoading = false;
      }
    },
    resetTempCreateAutoReply() {
      this.tempCreateAutoReply = {
        locationCode: '',
        replyBody: '',
        isSubmitLoading: false
      };
    },
    handleOmoOfflineAutoReplyError(errorCode, locationNameAndCode = '') {
      let errMsg = '';
      switch (errorCode) {
        case 14003:
          errMsg = this.$t('STAFF_MANAGEMENT.UPLOADER_IS_NOT_REGISTERED_IN_SALES_TABLE');
          break;
        case 14004:
          errMsg = this.$t('STAFF_MANAGEMENT.LOCATION_IS_NOT_REGISTERED_UNDER_THE_UPLOADER');
          break;
        case 14005:
          errMsg = this.$t('STAFF_MANAGEMENT.LOCATION_IS_NOT_REGISTERED_UNDER_THE_TEAM');
          break;
        case 14006:
          errMsg = this.$t('STAFF_MANAGEMENT.REPLY_BODY_IS_EMPTY').replace('{store}', locationNameAndCode);
          break;
        case 14007:
          errMsg = this.$t('STAFF_MANAGEMENT.CANNOT_CREATE_OFFLINE_AUTO_REPLY_BECAUSE_ONE_ALREADY_EXISTED');
          break;
        case 14008:
          errMsg = this.$t('STAFF_MANAGEMENT.CANNOT_UPDATE_OR_DELETE_OFFLINE_AUTO_REPLY_BECAUSE_NONE_EXISTED');
          break;
        default:
          errMsg = '';
          break;
      }
      const notificationObj = {
        title: this.$t('STAFF_MANAGEMENT.AUTO_REPLY_FAIL'),
        content: errMsg
      };
      this.$refs.notification.openNotification(notificationObj);
    }
  },
  mounted() {
    this.fetchAutoReplyList();
  }
};
</script>

<style lang="scss" scoped>
.store-auto-response {
  border: 1px solid $neutral-cold-054;
  border-radius: 4px;
}

.store-auto-response-title {
  position: relative;
  .add-action {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.store-auto-response-empty {
  padding: 28px 0;
  cursor: pointer;
}

.store-auto-response-list {
  padding: 16px;
  > :not(:last-child) {
    margin-bottom: 16px;
  }
}

.default-reply-textarea {
  position: relative;

  .textarea-tool {
    position: absolute;
    bottom: -42px;
    right: 0;
    z-index: 2;
    .tool-btn-group {
      background: $neutral-047;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      padding: 4px;
    }
  }
}

::v-deep.tool-btn {
  border-radius: 4px;
  &:not(:last-child) {
    margin-right: 2px;
  }
  &.theme--light.v-btn:hover::before,&.theme--light.v-btn:focus::before {
    border-radius: 4px;
    background: $primary-005;
    opacity: 1;
  }
}
</style>
